export const FILE_LIBRARY_ALL_MIMES = `
    image/png,
    image/jpeg,
    image/jpg,
    image/svg+xml,
    image/gif,
    image/webp,
    application/pdf,
    application/msword,
    application/vnd.openxmlformats-officedocument.wordprocessingml.document,
    text/plain,
    application/rtf,
    application/vnd.google-apps.document,
    application/vnd.oasis.opendocument.text,
    application/vnd.ms-excel,
    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
    application/vnd.google-apps.spreadsheet,
    application/vnd.oasis.opendocument.spreadsheet,
    video/mp4,
    video/quicktime,
    video/ogg,
    video/webm
`.replace(/\s+/g, "");

export const mimeToExtension = (mime) => {
  // handle each mime above
  switch (mime) {
  case "image/png":
    return "png";
  case "image/jpeg":
  case "image/jpg":
    return "jpg";
  case "image/svg+xml":
    return "svg";
  case "image/gif":
    return "gif";
  case "image/webp":
    return "webp";
  case "application/pdf":
    return "pdf";
  case "application/msword":
  case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
  case "application/vnd.google-apps.document":
  case "application/vnd.oasis.opendocument.text":
    return "docx";
  case "text/plain":
    return "txt";
  case "application/rtf":
    return "rtf";
  case "application/vnd.ms-excel":
  case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
  case "application/vnd.google-apps.spreadsheet":
  case "application/vnd.oasis.opendocument.spreadsheet":
    return "xlsx";
  case "video/mp4":
    return "mp4";
  case "video/quicktime":
    return "mov";
  case "video/ogg":
    return "ogg";
  case "video/webm":
    return "webm";
  default:
    return null;
  }
};

export const FILE_ATTACHMENT_PROPS = {
  attachments: {
    type: Array,
    default: () => [],
  },
  accept: {
    type: String,
    default: FILE_LIBRARY_ALL_MIMES,
    validator: (value) => {
      return value.split(",").every((mime) => {
        return FILE_LIBRARY_ALL_MIMES.includes(mime.trim());
      });
    }
  },
  maxFiles: {
    type: Number,
    default: 10,
  },
  maxFileSizeBytes: {
    type: Number,
    default: 4 * 1024 * 1024,
  },
  title: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  showFileLibrary: {
    type: Boolean,
    default: false,
  }
};

const excludedKeys = ["maxFiles", "attachments"];

export const FILTERED_FILE_ATTACHMENT_PROPS = Object.fromEntries(
  Object.entries(FILE_ATTACHMENT_PROPS).filter(([key]) => !excludedKeys.includes(key))
);

export const fileToAttachment = (file, order) => {
  const original_path = URL.createObjectURL(file);
  const original_size_bytes = file.size;
  const original_name = file.name;
  const current_name = file.name;

  const cleanup = () => URL.revokeObjectURL(original_path);

  const mime_type = file.type;

  return {
    file,
    original_path,
    original_size_bytes,
    original_name,
    current_name,
    mime_type,
    order,
    add_to_library: true,
    cleanup,
  };
};

export const MODEL_HAS_FILE_TAG_ATTACHMENTS = "attachments";
export const MODEL_HAS_FILE_TAG_SECURE = "secure";
export const MODEL_HAS_FILE_ONBOARDING = "onboarding";
